import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import StatusBadge from "../components/StatusBadge";
import { fmtDate } from "../lib/utils-app";
import { CalendarClock, Download, Eye } from "lucide-react";
import { toast } from "sonner";
import PreviewDialog from "../components/PreviewDialog";

const ENTITY_LABELS = { company: "Azienda", worker: "Lavoratore", site: "Cantiere", equipment: "Attrezzatura" };

export default function Scadenzario() {
  const [params, setParams] = useSearchParams();
  const status = params.get("status") || "";
  const entityType = params.get("entity_type") || "";
  const [items, setItems] = useState([]);
  const [preview, setPreview] = useState(null);

  const load = async () => {
    const { data } = await api.get("/scadenzario", { params: { status: status || undefined, entity_type: entityType || undefined } });
    setItems(data);
  };
  useEffect(() => { load(); }, [status, entityType]);

  const download = async (d) => {
    try {
      const res = await api.get(`/documents/${d.id}/download`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a"); a.href = url; a.download = d.original_filename; a.click();
      window.URL.revokeObjectURL(url);
    } catch { toast.error("Errore download"); }
  };

  const setF = (k, v) => {
    const p = new URLSearchParams(params);
    if (v) p.set(k, v); else p.delete(k);
    setParams(p);
  };

  return (
    <div className="space-y-6">
      <header>
        <div className="text-xs font-mono uppercase tracking-widest text-blue-700 mb-1">Monitoraggio</div>
        <h1 className="font-display text-3xl font-bold text-slate-900 flex items-center gap-2">
          <CalendarClock size={28} /> Scadenzario
        </h1>
        <p className="text-slate-500 mt-1">Tutti i documenti scaduti, in scadenza (entro 60 giorni) e regolari.</p>
      </header>

      <div className="flex flex-wrap gap-2">
        {[["", "Tutti"], ["valid", "Regolari"], ["expiring", "In scadenza"], ["expired", "Scaduti"]].map(([v, l]) => (
          <button key={v || "all"} onClick={() => setF("status", v)}
            data-testid={`filter-status-${v || "all"}`}
            className={`px-3 py-1.5 rounded-lg text-sm border ${status === v ? "bg-slate-900 text-white border-slate-900" : "bg-white border-slate-300 text-slate-700 hover:bg-slate-50"}`}>
            {l}
          </button>
        ))}
        <div className="w-px bg-slate-200 mx-2" />
        {[["", "Tutti tipi"], ["company", "Aziende"], ["worker", "Lavoratori"], ["site", "Cantieri"], ["equipment", "Attrezzature"]].map(([v, l]) => (
          <button key={v || "all"} onClick={() => setF("entity_type", v)}
            className={`px-3 py-1.5 rounded-lg text-sm border ${entityType === v ? "bg-blue-700 text-white border-blue-700" : "bg-white border-slate-300 text-slate-700 hover:bg-slate-50"}`}>
            {l}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto border border-slate-200 rounded-lg bg-white">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600">
            <tr>
              <th className="text-left px-4 py-3 font-medium">Documento</th>
              <th className="text-left px-4 py-3 font-medium">Categoria</th>
              <th className="text-left px-4 py-3 font-medium">Riferimento</th>
              <th className="text-left px-4 py-3 font-medium">Azienda</th>
              <th className="text-left px-4 py-3 font-medium">Scadenza</th>
              <th className="text-left px-4 py-3 font-medium">Stato</th>
              <th className="text-right px-4 py-3 font-medium">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && (
              <tr><td colSpan={7} className="text-center py-10 text-slate-500">Nessun documento trovato</td></tr>
            )}
            {items.map(d => (
              <tr key={d.id} className="border-t border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3">
                  <div className="font-medium text-slate-900">{d.nome}</div>
                  <div className="text-xs text-slate-500 font-mono">{d.original_filename}</div>
                </td>
                <td className="px-4 py-3">{d.categoria}</td>
                <td className="px-4 py-3">
                  <div className="text-xs text-slate-500">{ENTITY_LABELS[d.entity_type]}</div>
                  <div>{d.entity_name}</div>
                </td>
                <td className="px-4 py-3">
                  <Link to={`/aziende/${d.company_id}`} className="text-blue-700 hover:underline">{d.company_name}</Link>
                </td>
                <td className="px-4 py-3">{fmtDate(d.data_scadenza)}</td>
                <td className="px-4 py-3"><StatusBadge status={d.status} /></td>
                <td className="px-4 py-3 text-right">
                  <button onClick={() => setPreview(d)} data-testid={`preview-doc-${d.id}`} className="text-slate-700 hover:text-slate-900 p-1.5" title="Anteprima"><Eye size={16} /></button>
                  <button onClick={() => download(d)} className="text-blue-700 hover:text-blue-900 p-1.5"><Download size={16} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {preview && <PreviewDialog doc={preview} onClose={() => setPreview(null)} />}
    </div>
  );
}
